import React from "react";

const ImpactNumbers = () => {
  return (
    <div className="flex flex-col gap-3 h-full w-full px-1 py-[40px] container bg-white rounded-lg">
      <span className="text-3xl font-bold text-center text-green-800">Our Impact in Numbers</span>
      <span className="text-lg text-center text-gray-600 max-w-2xl mx-auto">
        Explore how IFJ is transforming careers and creating opportunities for
        aspiring professionals.
      </span>
      <section className="flex bg-gradient-to-br from-green-50 to-yellow-50 flex-wrap w-full items-center justify-center gap-6 p-6 rounded-xl my-6 shadow-sm border border-green-100">
        <div className="impact flex flex-col gap-3 bg-white p-6 rounded-lg shadow-md hover:shadow-lg transition-shadow duration-300 min-w-[200px] text-center border-l-4 border-green-600">
          <span className="text-4xl font-bold text-green-700">2 +</span>
          <span className="text-gray-700 font-medium">Internships Facilitated</span>
        </div>
        <div className="impact flex flex-col gap-3 bg-white p-6 rounded-lg shadow-md hover:shadow-lg transition-shadow duration-300 min-w-[200px] text-center border-l-4 border-yellow-500">
          <span className="text-4xl font-bold text-yellow-600">100%</span>
          <span className="text-gray-700 font-medium">Successful Placement Rate</span>
        </div>
        <div className="impact flex flex-col gap-3 bg-white p-6 rounded-lg shadow-md hover:shadow-lg transition-shadow duration-300 min-w-[200px] text-center border-l-4 border-green-600">
          <span className="text-4xl font-bold text-green-700">2 +</span>
          <span className="text-gray-700 font-medium">Partner Organizations</span>
        </div>
      </section>
    </div>
  );
};

export default ImpactNumbers;